/** API route map: URLS.Controller.Outlook */
export const Outlook = {
      Name: 'Outlook/',
      Integrate: 'integrate',
      GetDetails: 'get-details',
      Delete: 'delete-integration',
};
